import React from 'react';
const benefits = [{
  icon: '⏳',
  title: 'Ahorrás horas cada semana',
  desc: 'No más búsquedas interminables. Todo está en un solo lugar, organizado y listo.'
}, {
  icon: '✅',
  title: 'Trabajás con más claridad',
  desc: 'Sabés qué hacer, por qué lo hacés y qué viene después. Sin improvisar.'
}, {
  icon: '📌',
  title: 'Tenés recursos para cada necesidad',
  desc: 'Lenguaje, atención, motricidad, emociones, diversidad. Lo que necesites, cuando lo necesités.'
}, {
  icon: '✨',
  title: 'Ves avances más rápido y con menos desgaste',
  desc: 'Material concreto y visual = chicos más tranquilos, más enganchados, más progreso real.'
}, {
  icon: '🔄',
  title: 'Lo usás todos los años',
  desc: 'El material no vence. Lo reutilizás cada ciclo escolar con distintos grupos o chicos.'
}];
export function IncludesSection() {
  return <section className="py-10 md:py-20 px-4 bg-brand-dark text-white" data-id="element-174">
      <div className="max-w-4xl mx-auto" data-id="element-175">
        <div className="text-center mb-10 md:mb-16" data-id="element-176">
          <h2 className="text-3xl md:text-5xl font-black mb-4" data-id="element-177">
            ¿Qué cambia para vos?
          </h2>
          <p className="text-xl text-gray-300" data-id="element-178">
            Porque este pack no es solo para los chicos. Es para que vos también
            trabajes mejor.
          </p>
        </div>

        <div className="space-y-6" data-id="element-179">
          {benefits.map((b, i) => <div key={i} className="bg-[#252542] p-6 md:p-8 rounded-2xl border border-gray-700 flex flex-col md:flex-row gap-4 md:gap-6 items-start" data-id="element-180">
              <div className="text-4xl flex-shrink-0 bg-white/10 w-16 h-16 rounded-full flex items-center justify-center" data-id="element-181">
                {b.icon}
              </div>
              <div data-id="element-182">
                <h3 className="text-2xl font-bold mb-2 text-brand-orange" data-id="element-183">
                  {b.title}
                </h3>
                <p className="text-lg text-gray-300 leading-relaxed" data-id="element-184">
                  {b.desc}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}